// bytesToHex: takes each byte, turns it into a 2-character hex value, and joins them into the final hash string.
const bytesToHex = (bytes) =>
  Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");

export const normalizeAndHashEmail = async (email) => {
  if (typeof email !== "string" || !email.length) return "";
  // Web Crypto hashing requires modern browsers in a secure context.
  // If `window.crypto.subtle` is unavailable (for example older IE-era browsers),
  // we skip hashing and return an empty string instead of throwing.
  if (!window.crypto?.subtle || typeof TextEncoder === "undefined") return "";

  let normalized = email.toLowerCase().trim();

  if (
    normalized.includes("@gmail.com") ||
    normalized.includes("@googlemail.com")
  ) {
    const [localPart, domain] = normalized.split("@");
    const cleanLocal = localPart.split("+")[0].replaceAll(".", "");
    normalized = `${cleanLocal}@${domain}`;
  }

  const encoded = new TextEncoder().encode(normalized); // Convert the normalized email into a sequence of bytes using UTF-8 encoding.
  const digest = await window.crypto.subtle.digest("SHA-256", encoded); // Hash the encoded email using SHA-256.
  return bytesToHex(new Uint8Array(digest)); // Convert the hash to a hexadecimal string.
};

export const normalizePhone = (phone, countryCode = "") => {
  const phoneString = typeof phone === "string" ? phone : "";
  const countryCodeString =
    typeof countryCode === "string" ? countryCode.trim() : "";

  if (!phoneString.length) return "";

  const normalizedPhone = phoneString.replace(/\D/g, "");
  if (!normalizedPhone) return "";

  const normalizedCountryCode = countryCodeString.replace(/[^\d+]/g, "");

  if (!normalizedCountryCode) return normalizedPhone;

  const digitsOnlyCountryCode = normalizedCountryCode.replace(/\D/g, "");
  if (!digitsOnlyCountryCode) return normalizedPhone;

  return `+${digitsOnlyCountryCode}${normalizedPhone}`;
};

export const normalizeAndHashPhone = async (phone, countryCode = "") => {
  if (!window.crypto?.subtle || typeof TextEncoder === "undefined") return "";

  const normalized = normalizePhone(phone, countryCode);
  if (!normalized) return "";

  const encoded = new TextEncoder().encode(normalized);
  const digest = await window.crypto.subtle.digest("SHA-256", encoded);
  return bytesToHex(new Uint8Array(digest));
};
